import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { initializeKeycloak } from './app/auth/init/keycloak-init';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { tokenInterceptor } from './app/core/token.interceptor';
import { headerInterceptor } from './app/core/header.interceptor';
import { bootstrapApplication } from '@angular/platform-browser';
import routes from './app/app.routes';
import { NgChartsModule } from 'ng2-charts';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PlotlyViaCDNModule } from 'angular-plotly.js';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideRouter } from '@angular/router';

PlotlyViaCDNModule.setPlotlyVersion('2.20.0'); //TODO: is it ok??? maybe find plotly with tree-shaking

const DATE_FORMAT = 'MM/DD/YYYY';

const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: DATE_FORMAT,
  },
  display: {
    dateInput: DATE_FORMAT,
    monthYearLabel: DATE_FORMAT,
    dateA11yLabel: DATE_FORMAT,
    monthYearA11yLabel: DATE_FORMAT,
  },
};

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      NgChartsModule,
      PlotlyViaCDNModule,
      NgxGoogleAnalyticsModule.forRoot(`${environment.measurementId}`),
      NgxGoogleAnalyticsRouterModule,
      KeycloakAngularModule,
    ),
    provideAppInitializer(() => {
      const initializerFn = initializeKeycloak(inject(KeycloakService));
      return initializerFn();
    }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([tokenInterceptor, headerInterceptor])),
    provideAnimations(),
    provideAnimations(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'auto', appearance: 'outline' },
    },
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS),
  ],
}).catch((err) => console.error(err));
